import FieldsTranslation from "graphql/fields/FieldsTranslation";

export default `
	guid
    created_at
    code
    code_used_at
    status

    timeslot_kind {
        guid
    }
`;
